import Antd, { Spin, message } from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import { h } from "vue";
import LogoLoading from "~/components/LogoLoading.vue";
import { ICON_FONT_SCRIPT_URL } from "~/env";
import { createFromIconfontCN } from "@ant-design/icons-vue";
import "./index.less";

export default defineNuxtPlugin((nuxtApp) => {
  // 创建 IconFont 组件
  const IconFont = createFromIconfontCN({
    scriptUrl: ICON_FONT_SCRIPT_URL,
  });

  // 全局注册 IconFont 组件
  nuxtApp.vueApp.component("IconFont", IconFont);

  // 替换默认 Loading
  Spin.setDefaultIndicator({
    indicator: () => h(LogoLoading),
  });

  // 配置 message
  message.config({
    top: "4rem",
    maxCount: 1,
  });

  // 全局注册 Ant Design Vue
  nuxtApp.vueApp.use(Antd);
});
